import { useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { loginUser } from '../../services/authService';
import { useAuth } from '../../context/AuthContext';
import { setRefreshToken } from '../../utils/authCookies';

import bgImage from '../../../src/assets/images/backgrnd_miamar.png';
import logo from '../../../src/assets/images/miamr_logo.png';
import LoginContainer from '../../Components/Login/LoginContainer';
import LoginCard from '../../Components/Login/LoginCard';

import LoginHeader from '../../Components/Login/LoginHeader';
import LoginInput from '../../Components/Login/LoginInput';
import LoginActions from '../../Components/Login/LoginActions';
import LoginButton from '../../Components/Login/LoginButton';
import LoginLogo from '../../Components/Login/LoginLogo';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const validationSchema = Yup.object({
    username: Yup.string().required('Username is required'),
    password: Yup.string().required('Password is required'),
  });

  return (
    <Formik
      initialValues={{
        username: '',
        password: '',
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting, setStatus }) => {
        try {
          const response = await loginUser(values);

          setRefreshToken(response.refreshToken, response.refreshTokenExpiresAt);

          login(
            response.accessToken,
            {
              username: response.username,
              authorities: response.authorities,
            },
            response.accessTokenExpiresAt,
          );

          navigate('/Board&Committee');
        } catch (error: any) {
          setStatus(error?.response?.data?.message || 'Invalid username or password');
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {({ isSubmitting, status }) => (
        <Form>
          <LoginContainer>
            <LoginCard>
              <LoginLogo logo={logo} />

              <LoginHeader />

              <LoginInput name="username" label="Email" placeholder="name@example.com" />

              <LoginInput name="password" label="Password" type="password" placeholder="••••••••" />

              <LoginActions />

              {status && <div className="text-red-500 text-sm mb-4">{status}</div>}

              <LoginButton loading={isSubmitting} />
            </LoginCard>
          </LoginContainer>
        </Form>
      )}
    </Formik>
  );
};

export default Login;
